module.exports = __webpack_public_path__ + "static/media/show_left_blob.a56b679c.png";